import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceCenterState } from './service-center.state';

const selectServiceCenterSelector = createFeatureSelector<ServiceCenterState>('serviceCenter');

// Service Centers
export const selectAllServiceCenterState = createSelector(
  selectServiceCenterSelector,
  state => state.serviceCenters
);

export const selectIsServiceCenterLoadingState = createSelector(
  selectServiceCenterSelector,
  state => state.loading
);
